import React from 'react';
import { Section } from './ui/Section';
export function HowItWorks() {
  const steps = [{
    num: '01',
    title: 'Configura',
    desc: 'Aplicas el marco de estética Old Money a tu rincón de grabación y a tu perfil.'
  }, {
    num: '02',
    title: 'Graba',
    desc: 'Utilizas el Guion de Hierro para crear contenido que detenga el scroll de tu audiencia ideal.'
  }, {
    num: '03',
    title: 'Domina',
    desc: 'Publicas con autoridad y dejas que tu presencia atraiga a las personas que valoran tu sabiduría.'
  }];
  return <Section data-id="element-95">
      <div className="max-w-4xl mx-auto text-center" data-id="element-96">
        <h2 className="text-3xl md:text-4xl font-serif mb-16 text-navy" data-id="element-97">
          Cómo funciona
        </h2>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-98">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-px bg-gold/30 z-0" data-id="element-99"></div>

          {steps.map((step, index) => <div key={index} className="relative z-10 flex flex-col items-center" data-id="element-100">
              <div className="w-24 h-24 rounded-full bg-cream border border-gold flex items-center justify-center mb-6 shadow-sm" data-id="element-101">
                <span className="text-2xl font-serif text-gold-dark" data-id="element-102">
                  {step.num}
                </span>
              </div>
              <h3 className="text-xl font-serif text-navy mb-4" data-id="element-103">
                {step.title}
              </h3>
              <p className="text-charcoal-light font-light text-sm px-4" data-id="element-104">
                {step.desc}
              </p>
            </div>)}
        </div>
      </div>
    </Section>;
}